import Login from "./LoginComp";
import MfaLoginComp from "./mfa/MfaLoginComp";
import { MFA_LOGIN_V2 } from "../../config/featureFlags";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const LoginForm = () => {
  const isAuthenticated = useSelector(
    (state) => state.RS_Authentication.isAuthenticated
  );
  return (
    <div>
      {!isAuthenticated ? (
        <div
          className="login-wrapper overflow-auto"
          style={{
            minHeight: "100vh",
            height: "match-content",
          }}
        >
          {MFA_LOGIN_V2 ? <MfaLoginComp /> : <Login />}
        </div>
      ) : (
        <Navigate to="/" />
      )}
    </div>
  );
};

export default LoginForm;
